var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "vertical-slider ci-section py-0 offset-x" },
    [
      _vm.navigation
        ? _c(
            "a",
            {
              staticClass:
                "vertical-slider__nav prev d-flex align-items-center",
              on: { click: _vm.prev },
            },
            [_c("div", { staticClass: "mdi mdi-chevron-left mdi-36px" })]
          )
        : _vm._e(),
      _vm.navigation
        ? _c(
            "a",
            {
              staticClass:
                "vertical-slider__nav next d-flex align-items-center justify-content-end",
              on: { click: _vm.next },
            },
            [_c("div", { staticClass: "mdi mdi-chevron-right mdi-36px" })]
          )
        : _vm._e(),
      _vm.isMounted
        ? _c(
            "div",
            {
              ref: "slider",
              staticClass:
                "vertical-slider__wrapper ci-section py-0 offset-x hidden-overflow-scrollbar",
            },
            [
              _c(
                "div",
                {
                  staticClass: "vertical-slider__rail d-flex",
                  style: `width: ${_vm.sizes.rail}px`,
                },
                _vm._l(_vm.sliderItems, function (item, index) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "observe-visibility",
                          rawName: "v-observe-visibility",
                          value: {
                            callback: (state, entry) =>
                              _vm.visibilityChanged(state, entry, item),
                            throttle: 50,
                          },
                          expression:
                            "{ callback: (state, entry) => visibilityChanged(state, entry, item), throttle: 50 }",
                        },
                      ],
                      staticClass: "vertical-slider__item px-1 px-md-2 d-flex",
                      style: `width: ${_vm.sizes.item}px`,
                    },
                    [
                      _vm._t("default", null, {
                        loaded: item.loaded,
                        item: item.content,
                      }),
                    ],
                    2
                  )
                }),
                0
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }